import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { getLocalisedOpswatLink } from '@mdc/services';
import { Col } from 'react-bootstrap';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const FooterNavigation = () => {
    const { t, ready } = useTranslation();

    const [reports, setReports] = useState();
    const [resources, setResources] = useState();
    const [about, setAbout] = useState();

    useEffect(() => {
        setReports(
            <ul id='reports_footer'>
                <li className='group-header'>
                    {t('Reports')}
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/research-center')}
                    >
                        {t('Overview')}
                    </OutboundLink>
                </li>
                <li>
                    <Link
                        to='/reports/anti-malware-market-share'
                    >
                        {t('Market Share')}
                    </Link>
                </li>
                <li>
                    <Link
                        to='/reports/sanitization'
                    >
                        {t('Deep CDR')}
                    </Link>
                </li>
                <li>
                    <Link
                        to='/reports/outbreak'
                    >
                        {t('Malware Outbreak')}
                    </Link>
                </li>
                <li>
                    <Link
                        to='/reports/statistics'
                    >
                        {t('Package Efficacy')}
                    </Link>
                </li>
                <li>
                    <Link
                        to='/leaderboard'
                    >
                        {t('Leaderboard')}
                    </Link>
                </li>
            </ul>
        );

        setResources(
            <ul id='resources_footer'>
                <li className='group-header'>
                    {t('Resources')}
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/products/metadefender/cloud')}
                        rel='noopener noreferrer'
                    >
                        {t('Product Description')}
                    </OutboundLink>
                </li>
                <li>
                    <OutboundLink
                        href='https://onlinehelp.opswat.com/mdcloud/'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('APIs')}
                    </OutboundLink>
                </li>
                <li>
                    <Link
                        to='/vulnerabilities'
                    >
                        {t('Supported CVE list')}
                    </Link>
                </li>
                <li>
                    <OutboundLink
                        href='https://trust.opswat.com/'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('Service Status')}
                    </OutboundLink>
                </li>
                <li>
                    <OutboundLink
                        href='https://chrome.google.com/webstore/detail/opswat-file-security-for/fjampemfhdfmangifafmianhokmpjbcj/'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('Chrome Extension')}
                    </OutboundLink>
                </li>
                <li>
                    <OutboundLink
                        href='https://go.opswat.com/OPSWATCommunity/s/'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('Community Forum')}
                    </OutboundLink>
                </li>
            </ul>
        );

        setAbout(
            <ul id='about_footer'>
                <li className='group-header'>
                    {t('About')}
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/blog')}
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('OPSWAT Blog')}
                    </OutboundLink>
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/academy')}
                        rel='noopener noreferrer'
                    >
                        {t('OPSWAT Academy')}
                    </OutboundLink>
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/contact')}
                        id='footer-link-contact-us'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {t('Contact Us')}
                    </OutboundLink>
                </li>
                <li>
                    <Link
                        to='/licensing'
                    >
                        {t('Licensing')}
                    </Link>
                </li>
                <li>
                    <OutboundLink
                        href={getLocalisedOpswatLink('https://www.opswat.com/company/about')}
                        rel='noopener noreferrer'
                    >
                        {t('Company')}
                    </OutboundLink>
                </li>
                <li>
                    <Link
                        to="/store"
                    >
                        {t('Store')}
                    </Link>
                </li>
            </ul>
        );
    }, [t]);

    if (!ready) {
        return null;
    }

    return (
        <>
            <Col
                className='d-sm-block d-md-block d-lg-block d-xl-block group'
                lg={2}
                md={4}
                sm={4}
            >
                {reports}
            </Col>
            <Col
                className='d-sm-block d-md-block d-lg-block d-xl-block group'
                lg={2}
                md={4}
                sm={4}
            >
                {resources}
            </Col>
            <Col
                className='d-sm-block d-md-block d-lg-block d-xl-block group'
                lg={2}
                md={4}
                sm={4}
            >
                {about}
            </Col>
        </>
    );
};

export default FooterNavigation;
